"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const query = (0, client_1.gql) `
  mutation remapWebFlowSite($webFlowId: String!) {
    remapWebFlowSite(webFlowId: $webFlowId) {
      _id
      orgId
      sites {
        name
        webFlowId
        enabled
        createdAt
        updatedAt
        previewUrl
        domains {
          lastPublishedAt
          name
        }
      }
      entities {
        _id
        name
        selloutId
        entityType
        alwaysPublishTo
        webFlowIds {
          webFlowSiteId
          webFlowEntityId
          slug
        }
      }
    }
  }
`;
exports.default = query;
//# sourceMappingURL=remapWebFlowSite.mutation.js.map